import { Navigate } from 'react-router-dom';
import useAuthStore, { isProfileComplete } from '../store/useAuthStore';
import { PATHS } from './navConfig';

export default function ProtectedRoute({ children }) {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const user = useAuthStore((s) => s.user);
  if (!isAuthenticated) return <Navigate to={PATHS.LOGIN} replace />;
  /* Signed in but the account never finished sign-up — there is no class, no
     school and no profile behind it yet, so finish that first. */
  if (!isProfileComplete(user)) return <Navigate to={PATHS.SIGNUP} replace />;
  return children;
}
